export default __webpack_public_path__ + "static/google-9cd74f69a58ea5b7a3a1439dc4733b1a.svg";